export default "__VITE_ASSET__BTKf5f8U__"